import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { Helmet } from '../lib/HelmetShim';
import HeroSection from '../hooks/HeroSection';
import ProductSection from '../components/ProductSection';
import HowItWorksSection from '../components/HowItWorksSection';
import UploadWidget from '../components/UploadWidget';
import useCategoryData from '../hooks/useCategoryData';
import useMobileDetection from '../hooks/useMobileDetection';
import { client } from '../api/Api';

const Home: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isMobile = useMobileDetection();
    const [isSearching, setIsSearching] = useState(false);

    const {
        categories,
        products,
        loadMoreProducts,
        hasMoreProducts,
        isLoading,
        isLoadingMore,
        totalElements,
        setSearchResults,
    } = useCategoryData();




    const addCategoryToURL = (newCategory: string) => {
        const currentPath = location.pathname.replace(/\/$/, '');
        const newPath = `${currentPath}/${newCategory}`;
        navigate(newPath);
    };

    const handleSearch = async (searchQuery: string) => {
        if (searchQuery.trim()) {
            setIsSearching(true);
            try {
                const response = await client.post('/search', { query: searchQuery });
                setSearchResults(response.data.products);
            } catch (error) {
                navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
            }
        } else {
            setIsSearching(false);
        }
    };

    // Reset search state when location changes (e.g., navigating to category)
    React.useEffect(() => {
        const categoryPath = location.pathname.split('/').filter(Boolean);
        if (categoryPath.length === 0 || categoryPath[0] !== 'search') {
            setIsSearching(false);
        }
    }, [location.pathname]);

    return (
        <>
            <Helmet>
                <title>Tikrai – Kainų palyginimas, akcijos ir pasiūlymai Lietuvoje</title>
                <meta
                    name="description"
                    content="Raskite geriausias kainas ir akcijas. Tikrai.com padeda greitai palyginti produktų kainas ir išsirinkti geriausius pasiūlymus Lietuvoje."
                />
            </Helmet>
            <Container maxWidth="xl" className="container" sx={{ px: { xs: 1, sm: 2 } }}>
                <HeroSection
                    isMobile={isMobile}
                    categories={categories}
                    onCategorySelect={addCategoryToURL}
                    onSearch={handleSearch}
                />

                {!isMobile && !isSearching && <HowItWorksSection />}

                <ProductSection
                    products={products}
                    isLoading={isLoading}
                    isLoadingMore={isLoadingMore}
                    hasMoreProducts={hasMoreProducts}
                    totalElements={totalElements}
                    loadMoreProducts={loadMoreProducts}
                />
            </Container>
            <UploadWidget />
            <Box component="footer" sx={{ borderTop: '1px solid #eee', mt: 6, py: 3, backgroundColor: '#fafafa' }}>
                <Container maxWidth="lg" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center', alignItems: 'center' }}>
                    <a href="/api/taisykles.html" style={{ color: '#555', textDecoration: 'none' }}>Taisyklės</a>
                    <span style={{ color: '#bbb' }}>•</span>
                    <a href="/api/privacy-policy.html" style={{ color: '#555', textDecoration: 'none' }}>Privatumo politika</a>
                    <span style={{ color: '#bbb' }}>•</span>
                    <a href="/api/data-deletion.html" style={{ color: '#555', textDecoration: 'none' }}>Duomenų ištrynimas</a>
                </Container>
            </Box>
            <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      `}</style>
        </>
    );
};

export default Home;